// src/components/Backoffice/LicenseDashboard/ExpirationChart.tsx

import React from 'react';

interface Props {
  ano: number;
  porMes: number[];
}

const monthNames = [
  'Jan',
  'Fev',
  'Mar',
  'Abr',
  'Mai',
  'Jun',
  'Jul',
  'Ago',
  'Set',
  'Out',
  'Nov',
  'Dez',
];

const ExpirationChart: React.FC<Props> = ({ ano, porMes }) => {
  const monthlyCount = Array.from({ length: 12 }, (_, index) => porMes[index] ?? 0);
  const maxCount = Math.max(...monthlyCount, 1);

  return (
    <div className="bg-white p-4 rounded-lg shadow border border-gray-200">
      <h3 className="text-lg font-semibold text-gray-700 mb-4">
        Vencimentos por mês ({ano})
      </h3>

      <div className="flex items-end gap-2 h-40">
        {monthlyCount.map((count, index) => (
          <div key={monthNames[index]} className="flex-1 flex flex-col items-center">
            <div
              className="w-full bg-blue-400 rounded-t transition-all duration-300"
              style={{
                height: `${(count / maxCount) * 100}%`,
                minHeight: count > 0 ? '8px' : '0',
              }}
              title={`${monthNames[index]}: ${count} documento(s)`}
            />

            <span className="text-xs text-gray-500 mt-1">
              {monthNames[index]}
            </span>
          </div>
        ))}
      </div>
    </div>
  );
};

export default ExpirationChart;
